/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { JobCancelDetails } from "../types/JobCancelDetails";
export const Request = JobCancelDetails.optional();
